import React, { useCallback, useEffect, useState } from 'react';

import './Page.css';
import HSBCLogo from '../assets/hsbc-logo.png';
import { getParametersFromCurrentUrl } from '../api/getParameters';

type PageProps = {
  hsbcLogoAlt: string;
  sectionImgSrc: string;
  headerText: string;
  sectionText: string;
  appLaunchUrl?: string;
  buttonText: string;
};

function Page({ hsbcLogoAlt, sectionImgSrc, headerText, sectionText, buttonText, appLaunchUrl }: PageProps) {
  const parameters = getParametersFromCurrentUrl();
  const appLaunchWithParameters = `${appLaunchUrl}?${parameters.toString()}`;

  const [linkClicked, setLinkClicked] = useState(false);
  const [buttonVisible, setButtonVisible] = useState(true);

  const handleVisibilityChange = useCallback(() => {
    if (document.visibilityState === 'visible' && linkClicked) {
      setButtonVisible(false);
    }
  }, [linkClicked]);

  useEffect(() => {
    document.addEventListener('visibilitychange', handleVisibilityChange);
    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, [handleVisibilityChange]);

  return (
    <div className="App">
      <header className="App__Header">
        <img src={HSBCLogo} alt={hsbcLogoAlt} />
      </header>
      <div className="App__Main-Section">
        <img src={sectionImgSrc} className="Main-Logo" alt="" />
        <h1 className="Main-Title" aria-label={headerText}>
          {headerText}
        </h1>
        <p className="Main-Paragraph" aria-label={sectionText}>
          {sectionText}
        </p>
        {buttonVisible && (
          <a href={appLaunchWithParameters} className="Main-Button" role="button" onClick={() => setLinkClicked(true)}>
            {buttonText}
          </a>
        )}
      </div>
    </div>
  );
}

export default Page;
